import type { ReactNode } from 'react';
import { Heading, Paragraph } from '@zillow/constellation-10';

import { authCardColumn, authPageHeader, authPageStack } from './workflowPage.styles';

type AuthCardContainerProps = {
  children: ReactNode;
};

export function AuthCardContainer({ children }: AuthCardContainerProps) {
  return <div className={authCardColumn}>{children}</div>;
}

type AuthPageProps = AuthCardContainerProps & {
  title: string;
  description: string;
};

export function AuthPage({ title, description, children }: AuthPageProps) {
  return (
    <div className={authPageStack}>
      <header className={authPageHeader}>
        <Heading level={1} textStyle="heading-sm">
          {title}
        </Heading>
        <Paragraph>{description}</Paragraph>
      </header>
      <AuthCardContainer>{children}</AuthCardContainer>
    </div>
  );
}
